module.exports = __webpack_public_path__ + "static/media/plancapturefromsvg.pngBON.5ceb165e.png";